import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type A5TimeSerie, columns } from "./columns";
import { type FilterA5TimeSeriesSchema, FilterA5TimeSeries } from "./filter";

const client = Clients.A5;
const table_name = Tables.A5_TIME_SERIES;

export const A5TimeSeriesTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<A5TimeSerie>({
    client,
    table_name,
    resourceLabel: "Valorisation",
  });

  return (
    <>
      <Table<A5TimeSerie, FilterA5TimeSeriesSchema>
        label="Valorisation"
        client={client}
        table_name={table_name}
        columns={columns}
        filter={<FilterA5TimeSeries />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
